<div id="main-image">
    <div id="main-image-overlay" 
        [style]="'opacity: ' + contentData.imageOverlay.opacity + '; background-color: ' + contentData.imageOverlay.color"></div>
    <div *ngIf="contentData.circleDisplay" id="main-image-overlay-circle"
        [style]="'width: ' + contentData.circleDisplay.size + 'px; height: ' + contentData.circleDisplay.size + 'px; right: ' + contentData.circleDisplay.right + 'px; top: ' + contentData.circleDisplay.top + 'px;'">
        <div id="main-image-overlay-circle-text" [innerHtml]="contentData.circleDisplay.text"></div>
    </div>
    <img [src]="contentData.image" alt="">
</div>